import React from 'react';
import Layout from '../../components/Layout';
import PaymentComplete from '../../components/PaymentComplete';

const title = 'Payment Complete';

export default async function action({ store }) {
  // Note: Don't check authentication here - user may be redirected from Stripe
  // The component will handle verification of the payment intent
  return {
    title,
    component: <Layout><PaymentComplete title={title} /></Layout>,
  };
}
